export const APP_NAME = 'Doorsteps by ReHub';
export const APP_TAGLINE = 'Know which doors to knock on.';

export const DOORSTEPS_BASE_URL =
  (typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_DOORSTEPS_BASE_URL) ||
  process.env.VITE_DOORSTEPS_BASE_URL ||
  'https://doorsteps.rehub.studio';

// Default map view: Essex / London / Kent box.
export const DEFAULT_MAP_CENTER: [number, number] = [0.4, 51.55]; // [lng, lat]
export const DEFAULT_MAP_ZOOM = 9;

// Open OSM-based MapLibre style — no API key required.
export const MAP_STYLE_URL =
  'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';

// Stannp pricing: passthrough cost in pence per A5 letter, second-class.
// Updated periodically; we mark up 30-50% per spec.
export const STANNP_BASE_COST_PENCE = 65;     // approx per-letter cost
export const STANNP_MARKUP = 1.4;             // 40% markup
export const COST_PER_LETTER_PENCE = Math.round(STANNP_BASE_COST_PENCE * STANNP_MARKUP);

// Pipeline stages in display order.
export const PIPELINE_STAGES = [
  'prospect',
  'contacted',
  'valuation_booked',
  'instructed',
  'dead',
] as const;
export type PipelineStage = (typeof PIPELINE_STAGES)[number];

export const PIPELINE_LABELS: Record<PipelineStage, string> = {
  prospect: 'Prospect',
  contacted: 'Contacted',
  valuation_booked: 'Valuation Booked',
  instructed: 'Instructed',
  dead: 'Dead',
};

export const PIPELINE_COLORS: Record<PipelineStage, string> = {
  prospect: 'bg-slate-200 text-slate-700',
  contacted: 'bg-blue-100 text-blue-700',
  valuation_booked: 'bg-amber-100 text-amber-700',
  instructed: 'bg-emerald-100 text-emerald-700',
  dead: 'bg-rose-100 text-rose-700',
};

export const PROPERTY_TYPES = [
  'detached',
  'semi',
  'terraced',
  'flat',
  'other',
] as const;
export type PropertyType = (typeof PROPERTY_TYPES)[number];

export const PROPERTY_TYPE_LABELS: Record<PropertyType, string> = {
  detached: 'Detached',
  semi: 'Semi-detached',
  terraced: 'Terraced',
  flat: 'Flat / maisonette',
  other: 'Other',
};

export const ACTIVITY_TYPES = [
  'letter_sent',
  'qr_scanned',
  'form_submitted',
  'stage_changed',
  'note_added',
  'call_logged',
] as const;
export type ActivityType = (typeof ACTIVITY_TYPES)[number];

export const ACTIVITY_LABELS: Record<ActivityType, string> = {
  letter_sent: 'Letter sent',
  qr_scanned: 'QR scanned',
  form_submitted: 'Form submitted',
  stage_changed: 'Stage changed',
  note_added: 'Note added',
  call_logged: 'Call logged',
};

export const DEFAULT_FILTERS = {
  min_ownership: 7,        // years
  min_epc_age: 8,          // years
  min_score: 50,
  property_types: [...PROPERTY_TYPES] as PropertyType[],
  min_price: undefined as number | undefined,
  max_price: undefined as number | undefined,
};

export type FilterState = typeof DEFAULT_FILTERS;

// V1 ships with one letter template. ID lives here; copy in services/letter-template.ts.
export const DEFAULT_TEMPLATE_ID = 'classic_v1';
